/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-30 15:07:59
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-02 20:46:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Currency/Components/CurrencyModal/service/index.tsx
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrencies } from '@/src/constrains/GlobalProvider/slice';
import { getRealTimeExchangeRate } from '@/src/request/currency';
import { Currency, INITIAL_STATE } from '../../../constant';
import { get, isNumber } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
type Error = {
  type: string;
  message: string;
};

function useService(currencyList: Array<any>, editingCurrency: Currency) {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [error, setError] = useState({} as Error);
  // const [maxDisable, setMaxDisable] = useState(true);
  // const [minDisable, setMinDisable] = useState(true);
  const [realTimeRate, setRealTimeRate] = useState(0);
  const [currency, setCurrency] = useState<Currency>(INITIAL_STATE);
  const [isChanged, setIsChanged] = useState<boolean>(false);
  const currencies: Array<any> = useSelector(getCurrencies());

  const options = currencies.filter(
    (c) => !currencyList.find((v) => v.code === c.code) && !c.reportingCurrency,
  );

  const reportingCurrencies =
    currencies?.filter((c) => c.reportingCurrency)[0] || {};

  const handleChange = (v: any) => {
    setCurrency({ ...currency, currencyCode: v.value, currencyName: v.label });
    setIsChanged(true);
  };

  const handleChangeRate = (value: number) => {
    setCurrency({ ...currency, rate: value });
    setIsChanged(true);
  };

  const handleChangeFixedRate = (fixedRate: boolean) => {
    setIsChanged(true);
    setError({} as Error);
    const o = { ...currency, fixedRate };
    if (!fixedRate) {
      const minRate = get(currency, 'minRate');
      if (!isNumber(minRate)) {
        o.minRate = 0;
      }
    }
    setCurrency(o);
  };

  const handleChangeMax = (e: any) => {
    setIsChanged(true);
    setError({} as Error);
    setCurrency({ ...currency, maxRateChecked: e.target.checked });
    //  setMaxDisable(!e.target.checked);
  };

  const handleChangeMin = (e: any) => {
    setIsChanged(true);
    setError({} as Error);
    setCurrency({ ...currency, minRateChecked: e.target.checked });
    // setMinDisable(!e.target.checked);
  };

  const handleChangeFluRate = (type: string, value: number) => {
    setError({} as Error);
    if (type === 'max') {
      setCurrency({ ...currency, maxRate: value });
      setIsChanged(true);
    }
    if (type === 'min') {
      setCurrency({ ...currency, minRate: value });
      setIsChanged(true);
    }
  };

  const validation = () => {
    if (get(currency, 'minRateChecked') || get(currency, 'maxRateChecked')) {
      if (!isNumber(currency.maxRate)) {
        setError({
          type: 'maxNull',
          message: getI18n('general.fieldCannotEmpty'),
        });
        return false;
      }
      if (!isNumber(currency.minRate)) {
        setError({
          type: 'minNull',
          message: getI18n('general.fieldCannotEmpty'),
        });
        return false;
      }
      if (currency.maxRate < currency.minRate) {
        setError({
          type: 'max&min',
          message: `Minimum rate can't be higher than maximum rate`,
        });
        return false;
      }
    }

    return true;
  };

  const handleSubmit = () => {
    setIsChanged(false);
    return validation();
  };

  useEffect(() => {
    if (currency.currencyCode) {
      getRealTimeExchangeRate(
        reportingCurrencies.code,
        currency.currencyCode,
      ).then((res: number) => {
        setRealTimeRate(res);
        const c: any = { ...(currency || {}) };
        // if (!get(currency, 'realTimeRate') || !get(currency, 'rate')) {
        //   setCurrency({ ...currency, rate: res, realTimeRate: res });
        // }
        if (!get(c, 'rate')) {
          c.rate = res;
        }
        if (!get(c, 'realTimeRate')) {
          c.realTimeRate = res;
        }
        setCurrency(c);
      });
    }
  }, [currency.currencyCode]);

  useEffect(() => {
    setCurrency(editingCurrency);
  }, [editingCurrency]);

  return {
    isChanged,
    error,
    currency,
    realTimeRate,

    options,
    reportingCurrencies,
    handleSubmit,
    handleChange,
    handleChangeMax,
    handleChangeMin,
    handleChangeRate,
    handleChangeFluRate,
    handleChangeFixedRate,
  };
}

export default useService;
